<template>
	<div class="gb-photoalbum-item-not-reference mark-not-reference"></div>
</template>
<script>
export default {
	name: 'GBPhotoAlbumItemNotReference',
	props: [
	],
	data() {
		return {
		};
	},
	methods: {
	},
}
</script>
<style>
	.gb-photoalbum-item-not-reference.mark-not-reference {
		position: absolute;
		display: inline-block;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background-color: #32cd32;
		color: #fff;
		text-align: center;
		line-height: 7px;
		z-index: 101;
	}
</style>
